$(function() {
    $('.map-responsive').click(function(e) {
        $('.map-responsive iframe').css('pointer-events', 'all');
    }).mouseleave(function(e) {
        $('.map-responsive iframe').find('iframe').css('pointer-events', 'none');
    });
})

  


  $( function() {
    
    var icons = {
      header: "ui-icon-plus",
      activeHeader: "ui-icon-minus"
    };
    
    $( ".accordion" ).accordion({
	 icons: icons,
      heightStyle: "content",
                 collapsible: true,
            active: false
    });
  } );